import useAppState from "helpers/useAppState";
import { userRoles } from "helpers/userRoles";
import Config from "config/Config";

const usePermissions = () => {
  const { profile: userProfile, canAccessBilling } = useAppState().user;

  return {
    role: userProfile,
    isSubcontractor: userRoles.SUBCONTRACTOR === userProfile,
    canAccessBilling:
      userRoles.SUBCONTRACTOR === userProfile && canAccessBilling === true,
    isUserAndDown: [userRoles.USER, userRoles.CONTRACTOR].includes(userProfile),
    isContractorAndUp: [
      userRoles.ADMIN,
      userRoles.SUPER_ADMIN,
      userRoles.MANAGER,
      userRoles.CONTRACTOR,
    ].includes(userProfile),
    isManagerAndUp: [
      userRoles.ADMIN,
      userRoles.SUPER_ADMIN,
      userRoles.MANAGER,
    ].includes(userProfile),
    isUserAndUp: [
      userRoles.SUPER_ADMIN,
      userRoles.ADMIN,
      userRoles.MANAGER,
      userRoles.USER,
    ].includes(userProfile),
    isAdmin: [userRoles.ADMIN, userRoles.SUPER_ADMIN].includes(userProfile),
    isSuperAdmin: userProfile === userRoles.SUPER_ADMIN,
    isContractor: userRoles.CONTRACTOR === userProfile,
    isManager: userRoles.MANAGER === userProfile,
    isUser: userRoles.USER === userProfile,
    canSeeOrderContent: (() => {
      const role = Config.get("orderContentAdminRole");
      if (role === "user")
        return [
          userRoles.SUPER_ADMIN,
          userRoles.ADMIN,
          userRoles.MANAGER,
          userRoles.USER,
        ].includes(userProfile);
      if (role === "manager")
        return [
          userRoles.ADMIN,
          userRoles.SUPER_ADMIN,
          userRoles.MANAGER,
        ].includes(userProfile);
      if (role === "admin")
        return [userRoles.ADMIN, userRoles.SUPER_ADMIN].includes(userProfile);
      return false;
    })(),
  };
};

export default usePermissions;
